import React from 'react'
import { Card, CardContent, Grid, Icon, Typography } from '@mui/material'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'

const NoDataPanel = ({ message }) => (
    <Grid container size={12} justifyContent='center' alignItems='center' spacing={1} sx={{ padding: '5 10 5 0' }}>
        <CloudOffIcon />
        <Typography variant='h6' fontWeight='bold'>{message ?? i18n.noDataToDisplay}</Typography>
    </Grid>
)

NoDataPanel.propTypes = {
    message: PropTypes.string,
}

const NoDataCard = ({ message }) => (
    <Card>
        <CardContent>
            <NoDataPanel message={message} />
        </CardContent>
    </Card>
)

NoDataCard.propTypes = {
    message: PropTypes.string,
}

const NoDataPanelColumn = ({ message }) => (
    <Grid container size={12} sx={{ fontSize: 14, color: 'black' }} justifyContent='center' alignItems='center' direction='column' spacing={0}>
        <Grid size='auto'>
            <Icon style={{ fontSize: 50 }}>cloud_off</Icon>
        </Grid>
        <Grid size='auto'>
            {message ?? i18n.noResults}
        </Grid>
    </Grid>
)

NoDataPanelColumn.propTypes = {
    message: PropTypes.string,
}

export { NoDataCard, NoDataPanel, NoDataPanelColumn }